"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chips = function Chips(_ref) {
  var title = _ref.title,
      data = _ref.data,
      onDelete = _ref.onDelete,
      variant = _ref.variant;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("h6", {
    className: "chip-title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "chip-container"
  }, data.length ? data.map(function (d, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: "chip-content ".concat(variant)
    }, /*#__PURE__*/_react.default.createElement("span", null, d.label), onDelete ? /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return onDelete(d);
      },
      className: "button ".concat(variant)
    }, "x") : null);
  }) : null));
};

var _default = Chips;
exports.default = _default;
Chips.propTypes = {
  title: _propTypes.default.string,
  data: _propTypes.default.array,
  onDelete: _propTypes.default.func,
  variant: _propTypes.default.oneOf(['dark', 'light', 'info', 'primary'])
};
Chips.defaultProps = {
  title: '',
  onDelete: null,
  variant: 'light',
  data: []
};